import { Navigate, Routes, Route } from "react-router-dom";
import { Home, Accounts, Settings, Blog, LoginPage, Respons, SignUp, ResetPassword, TwoFactor, Profile, Landing, Contact, Dashboards, DashboardManagement, LoonOpZandDashboard, LoonOpZandTextAnswers } from "./pages";
import ProtectedRoute from "./components/ProtectedRoute";

function App() {
  return (
    <Routes>
      {/******************** AUTH ********************/}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/signup" element={<SignUp />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/2fa" element={<TwoFactor />} />

      {/****************** APP PAGES *****************/}
      <Route path="/" element={<Landing />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/accounts" element={
        <ProtectedRoute allowedRoles={["admin", "superadmin"]}>
          <Accounts />
        </ProtectedRoute>
      } />
      <Route path="/settings" element={
        <ProtectedRoute>
          <Settings />
        </ProtectedRoute>
      } />
      <Route path="/profile" element={
        <ProtectedRoute>
          <Profile />
        </ProtectedRoute>
      } />
      <Route path="/dashboard" element={
        <ProtectedRoute requiredOnderzoek="ceo-holland-rijnland">
          <Home />
        </ProtectedRoute>
      } />
      <Route path="/dashboards" element={
        <ProtectedRoute>
          <Dashboards />
        </ProtectedRoute>
      } />
      <Route path="/dashboards/loon-op-zand" element={
        <ProtectedRoute requiredOnderzoek="loon-op-zand">
          <LoonOpZandDashboard />
        </ProtectedRoute>
      } />
      <Route path="/dashboards/loon-op-zand/tekstantwoorden" element={
        <ProtectedRoute allowedRoles={["superadmin"]}>
          <LoonOpZandTextAnswers />
        </ProtectedRoute>
      } />
      <Route path="/onderzoek-beheer" element={
        <ProtectedRoute allowedRoles={["superadmin"]}>
          <DashboardManagement />
        </ProtectedRoute>
      } />
      <Route path="/dashboard-beheer" element={<Navigate to="/onderzoek-beheer" replace />} />
      <Route path="/blog" element={
        <ProtectedRoute>
          <Blog />
        </ProtectedRoute>
      } />
      <Route path="/respons" element={
        <ProtectedRoute
          allowedRoles={["admin", "superadmin"]}
          requiredOnderzoek="ceo-holland-rijnland"
        >
          <Respons />
        </ProtectedRoute>
      } />
    </Routes>
  );
}

export default App;
